<div class="wrapper">
  @for(bar of bars();track bar; let i=$index){
  <div class="bar" [ngClass]="{ selected: i === selected() }" (click)="select(i)">
    <div class="visible_bar"></div>
  </div>
  }
</div>
